<template>
  <ChartContainer
    :chartOptions="getChartHighchartsOptions"
    :key="selectedChartType.value"
  >
    <template #header>
      <v-row no-gutters>
        <v-col no-gutters cols="8">
          <h3 class="font-weight-light" style="color: var(--color-text)">
            Charts
          </h3>
        </v-col>
        <v-col cols="4">
          <div class="custom-select-height">
            <ThemedSelector
              :items="chartTypeOptions"
              :item-text="(item) => item.text"
              v-model="selectedChartType"
              auto-select-first
              no-data-text="No routes found"
              return-object
              cache-items
              outlined
              height="28"
              append-icon="none"
              label="Select chart"
              persistent-placeholder
              class="mx-2 custom-select-height"
              :menu-props="{ bottom: true, offsetY: true }"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </ChartContainer>
</template>

<script>
import { mapGetters } from "vuex";
import ChartContainer from "./ChartContainer.vue";
import ThemedSelector from "@/core/ThemedSelector.vue";
export default {
  name: "ResultsCharts",
  components: {
    ChartContainer,
    ThemedSelector,
  },
  data() {
    return {
      chartTypeDict: {
        "RPM - Power": "rpm_power",
        "RPM - Consumption": "rpm_consumption",
        "Speed - Power": "speed_power",
        "Speed - Consumption": "speed_consumption",
        "Power - Consumption": "power_consumption",
      },
      chartTypeOptions: [
        {
          text: "Consumption - Speed",
          value: "speed_consumption",
        },
        {
          text: "Power - RPM",
          value: "rpm_power",
        },
        {
          text: "Consumption - RPM",
          value: "rpm_consumption",
        },
        {
          text: "Power - Speed",
          value: "speed_power",
        },
        {
          text: "Consumption - Power",
          value: "power_consumption",
        },
      ],
      selectedChartType: null,
    };
  },
  computed: {
    ...mapGetters("kDiagram", [
      "rpmPowerChartOptions",
      "rpmConsumptionChartOptions",
      "speedPowerChartOptions",
      "speedConsumptionChartOptions",
      "powerConsumptionChartOptions",
      "rpmConsumptionChartOptions",
    ]),
    chartTypes() {
      return Object.keys(this.chartTypeDict);
    },
    getChartHighchartsOptions() {
      switch (this.selectedChartType.value) {
        case "rpm_power":
          return this.rpmPowerChartOptions;
        case "rpm_consumption":
          return this.rpmConsumptionChartOptions;
        case "speed_power":
          return this.speedPowerChartOptions;
        case "speed_consumption":
          return this.speedConsumptionChartOptions;
        case "power_consumption":
          return this.powerConsumptionChartOptions;
        default:
          return this.speedConsumptionChartOptions;
      }
    },
  },
  created() {
    this.selectedChartType = this.chartTypeOptions[3];
  },
};
</script>
